export default {
  expertHDP: "expert_hdp",
  paHDP: "pa_hdp"
};
